var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('router-view'),_vm._v(" "),(_vm.receivingCall !== null)?_c('call-in',{attrs:{"caller":_vm.receivingCall},on:{"accept":_vm.acceptCallIn,"reject":_vm.rejectCallIn,"videoOnOff":_vm.videoOnOff,"stopStream":_vm.stopStream}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-416be50f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 